import React from "react";
import * as styles from "/src/components/Resource/ResourceCategories.module.css";
import { v4 as uuidv4 } from "uuid";
import slugify from "slugify";
import { getMonth } from "/src/services/utils.js";
import { Link } from "gatsby";

const BlogCategories = (props) => {
  const allBlogs = props.data;
  let groupedBlog = {};

  for (const value of allBlogs) {
    var d = new Date(value["createdAt"]).getFullYear();
    if (groupedBlog.hasOwnProperty(d)) {
      groupedBlog[d].push(value);
    } else {
      groupedBlog[d] = [value];
    }
  }
  for (const year in groupedBlog) {
    groupedBlog[year].sort(
      (a, b) => Date.parse(b.createdAt) - Date.parse(a.createdAt)
    );
  }

  let categories = Object.keys(groupedBlog);
  const Categories = () => {
    return (
      <div className={styles.dataContainer}>
        {categories.map((year) => (
          <div
            key={uuidv4()}
            style={{ boxSizing: "border-box" }}
            className={`p-15`}
          >
            <div className={styles.categoryTitle}>{year}</div>
            <ul>
              {groupedBlog[year].map((entry) => {
                let dateObj = new Date(entry["createdAt"]);

                return (
                  <li
                    key={uuidv4()}
                    className={styles.categoryList}
                    style={{ display: "flex", marginBottom: 20 }}
                  >
                    <div
                      style={{
                        fontWeight: "bold",
                        fontSize: "1.1rem",
                        color: "black",
                        marginRight: "15px",
                        minWidth: "60px",
                      }}
                    >
                      {dateObj.getDate() + " "}{" "}
                      {getMonth(dateObj.getMonth()).substring(0, 3)}
                    </div>
                    <Link
                      to={`/blog/${slugify(entry["title"], {
                        lower: true,
                        strict: true,
                      })}`}
                      className={styles.categoryItem}
                    >
                      {entry["title"]}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
        ))}
      </div>
    );
  };
  return (
    <>
      <div
        className="section-header left-header pv-10"
        style={{ justifyContent: "center" }}
      >
        Articles by Date
      </div>
      <div
        style={{ justifyContent: "space-around" }}
        className={styles.categoryWrapper}
      >
        <Categories />
      </div>
    </>
  );
};

export default BlogCategories;
